import { Link } from '@tanstack/react-router';

import { cn } from '@/lib/cn';
import type { Brand } from '@/lib/types';

export function BrandFilter({
  brands,
  active,
}: {
  brands: Brand[];
  active: string | null;
}) {
  const pill =
    'inline-flex h-11 items-center rounded-full border px-4 text-sm font-semibold transition-colors';

  return (
    <nav aria-label="Filter by brand" className="flex flex-wrap gap-2">
      <Link
        to="/shop"
        aria-current={active === null ? 'page' : undefined}
        className={cn(
          pill,
          active === null
            ? 'border-ink bg-ink text-panel'
            : 'border-line-strong bg-panel hover:border-ink/40',
        )}
      >
        All brands
      </Link>
      {brands.map((b) => (
        <Link
          key={b.id}
          to="/shop/$brand" params={{ brand: b.slug }}
          aria-current={active === b.slug ? 'page' : undefined}
          className={cn(
            pill,
            active === b.slug
              ? 'text-panel'
              : 'border-line-strong bg-panel hover:border-ink/40',
          )}
          style={
            active === b.slug
              ? { background: b.accent_hex, borderColor: b.accent_hex }
              : undefined
          }
        >
          {b.name}
        </Link>
      ))}
    </nav>
  );
}
